export type ProductCollection = {
  id: string;
  title: string;
  handle: string;
};

export type ProductFilters = {
  occasion: string[];
  humorStyle: string[];
  season: string[];
  audience: string[];
};

export type ProductVariant = {
  id: number;
  gid?: string;
  color: string;
  size: string;
  price: number;
  image?: string;
  available?: boolean;
};

export type Product = {
  id: string;
  gid?: string;
  title: string;
  description: string;
  phrase: string;
  collection: string;
  collectionHandle: string;
  collections: ProductCollection[];
  buyer: string;
  trigger: string;
  price: number;
  colors: string[];
  sizes: string[];
  image: string;
  imagesByColor: Record<string, string>;
  handle: string;
  productType: string;
  tags: string[];
  filters: ProductFilters;
  urgency: "Build now" | "Seasonal push" | "Core catalog";
  shopifyProductId?: number;
  variants: ProductVariant[];
};

export type CatalogFilters = {
  productTypes?: string[];
  tags?: string[];
  colors?: string[];
  sizes?: string[];
  occasions?: string[];
  humorStyles?: string[];
  seasons?: string[];
  audiences?: string[];
};

export type CatalogPayload = {
  source?: string;
  sourceMode?: "storefront-api" | "public-json";
  updatedAt?: string;
  totalProducts?: number;
  collections?: ProductCollection[];
  filters?: CatalogFilters;
  products?: Product[];
  error?: string;
};

export const products: Product[] = [];
export const collections = ["All"];
